enum LegacyDocumentType {
  HIPAA_NOTICE = 'notice',
  MEDICAL_WAIVER = 'medical-waiver',
  PURCHASE_DELIVERY_RECEIPT = 'purchase-delivery-receipt',
}

enum LegacyConsentDocumentType {
  DATA_PRIVACY = 'data-privacy-consent',
  HIPAA_NOTICE = 'notice-consent',
  MEDICAL_WAIVER = 'medical-waiver-consent',
}

export { LegacyConsentDocumentType as ConsentDocumentType, LegacyDocumentType as DocumentType }
